import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import _ from 'lodash';

import {
  fetchChannelEvent,
  fetchInteractions,
  copyToClipboard,
  changeChannelSocket,
  updateClientsMobileConnected,
  updateListClientsConnected,
  fetchInteractionAnalytics,
  onCloseDialogAnalytics,
  filterOption,
  closeDataListView,
  setCheckingMobileConnection,
} from './actions';

export const initialState = {
  channelId: null,
  event: null,

  interactionsList: [],
  interactionsPageSize: 10,

  leagueSelected: null,
  gameSelected: null,

  leaguesList: [],
  teamsList: [],

  socket: null,
  listClientsConnected: [],

  analyticsDialog: false,
  interactionAnalytics: null,
  usersAnalytics: null,
  dataListView: false,
  checkingMobileConnection: false,
  clientsMobileConnected: [],
};

export const reducer = handleActions(
  {
    [fetchChannelEvent]: {
      next: (state, { payload }) => {
        let newLeagueSelected = null;
        let newGameSelected = null;

        if (payload && payload.game) {
          const game = payload.game;

          if (game && game._id) {
            newLeagueSelected = game.leagueId;
            newGameSelected = game.gameId;
          }
        }

        const newState = update(state, {
          event: { $set: payload || {} },
          leagueSelected: { $set: newLeagueSelected || null },
          gameSelected: { $set: newGameSelected || null },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          event: { $set: {} },
          leagueSelected: { $set: null },
          gameSelected: { $set: null },
        });
      },
    },
    [setCheckingMobileConnection]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          checkingMobileConnection: { $set: payload || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          checkingMobileConnection: { $set: false },
        });
      },
    },
    [fetchInteractions]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          interactionsList: { $set: payload || [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          interactionsList: { $set: [] },
        });
      },
    },
    [copyToClipboard]: {
      next: (state, { payload }) => {
        //temporary input to copy the url
        var tempInput = document.createElement('input');
        document.body.appendChild(tempInput);
        tempInput.setAttribute('id', 'tempInput_id');
        document.getElementById('tempInput_id').value = payload;
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        return state;
      },
      throw: state => {
        return state;
      },
    },
    [changeChannelSocket]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          socket: { $set: payload || null },
          listClientsConnected: { $set: [] },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          socket: { $set: null },
          listClientsConnected: { $set: [] },
        });
      },
    },
    [updateClientsMobileConnected]: {
      next: (state, { payload }) => {
        if (!_.isEqual(payload, state.clientsMobileConnected)) {
          const newState = update(state, {
            clientsMobileConnected: { $set: payload || [] },
          });

          return newState;
        }
        return state;
      },
      throw: state => {
        return update(state, {
          clientsMobileConnected: { $set: [] },
        });
      },
    },
    [updateListClientsConnected]: {
      next: (state, { payload }) => {
        let listClientsConnected = [];
        if (payload && payload.length) {
          listClientsConnected = payload;
        }

        const newState = update(state, {
          listClientsConnected: { $set: listClientsConnected || [] },
        });
        return newState;
      },
      throw: state => {
        return update(state, {
          listClientsConnected: { $set: [] },
        });
      },
    },
    [fetchInteractionAnalytics]: {
      next: (state, { payload }) => {
        if (_.isEmpty(payload)) {
          payload = { isNull: true };
        }
        const newState = update(state, {
          interactionAnalytics: { $set: payload || null },
          analyticsDialog: { $set: true || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          interactionAnalytics: { $set: null },
          analyticsDialog: { $set: false },
        });
      },
    },
    [filterOption]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          usersAnalytics: { $set: payload || null },
          dataListView: { $set: true || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          usersAnalytics: { $set: null },
          dataListView: { $set: false },
        });
      },
    },
    [onCloseDialogAnalytics]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          analyticsDialog: { $set: payload || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          analyticsDialog: { $set: false },
        });
      },
    },
    [closeDataListView]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          dataListView: { $set: payload || false },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          dataListView: { $set: false },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
